import React from 'react'
import { Checkbox} from '@softura/fluentuipackage'
import './Checkbox.scss'

interface IProps {
  label?: string,
  className?: string|number,
  onChange?: any,
  defaultChecked?: boolean,
  disabled?: boolean,
  key?: any,
  checked?:any,
  title?:any,
  'data-attribute'?: any
}
const CheckboxComponent = ({
  label = '',
  className = '',
  onChange,
  defaultChecked = false,
  disabled = false,
  key,
  checked,
  title,
  'data-attribute': dataAttribute
}:IProps) => {
  return <div data-attribute={dataAttribute}>
    <Checkbox
    className={`form-checkbox ${className}`}
    label = {label}
    onChange = {onChange}
    defaultChecked = {defaultChecked}
    disabled = {disabled}
    key={key}
    checked={checked}
    title={title} />
  </div>
}

export default CheckboxComponent
